import { Service } from "typedi";
import { RPCCommandRegistry } from "./RPCCommandRegistry";
import type { AgentRPCCommandMap } from "./AgentRPCCommandMap";

@Service()
export class AgentRPCCommands extends RPCCommandRegistry<AgentRPCCommandMap> {}
